import {useState} from 'react';
import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {DhcpLease} from '../../Types/routerForms';
import {useAddLease, useRemoveLease} from '../../Hooks/RouterManager';
import AddDhcpLeaseModal from './AddDhcpLeaseModal';
import ActionIcon from '../../../../Components/ActionIcon';
import Level3Title from '../../../../app/common/components/title/Level3Title';

interface DhcpLeasesSectionProps {
  routerId: string;
  leases: DhcpLease[];
}

const DhcpLeasesSection = ({routerId, leases}: DhcpLeasesSectionProps): JSX.Element => {
  const intl = useIntl();
  const [showAdd, setShowAdd] = useState(false);
  const addLease = useAddLease(routerId);
  const removeLease = useRemoveLease(routerId);

  const handleDelete = (id: string) => {
    if (
      window.confirm(intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.CONFIRM_DELETE'}))
    ) {
      removeLease.mutate(id);
    }
  };

  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title>
          <Level3Title title={intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.TITLE'})} />
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <table className="table table-row-dashed align-middle">
          <thead>
            <tr className="fw-semibold text-muted">
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.IP'})}</th>
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.MAC'})}</th>
              <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.RESERVED'})}</th>
              <th style={{width: 60}}></th>
            </tr>
          </thead>
          <tbody>
            {leases.length === 0 && (
              <tr>
                <td colSpan={4} className="text-muted text-center">
                  {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.EMPTY'})}
                </td>
              </tr>
            )}
            {leases.map((l) => (
              <tr key={l.id}>
                <td>{l.ip}</td>
                <td>{l.mac}</td>
                <td>{intl.formatMessage({id: l.reserved ? 'COMMON.YES' : 'COMMON.NO'})}</td>
                <td>
                  <ActionIcon
                    label={intl.formatMessage({id: 'COMMON.DELETE'})}
                    faIcon="fa-solid fa-trash text-danger"
                    onClick={() => handleDelete(l.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className="btn btn-light btn-sm" onClick={() => setShowAdd(true)}>
          <i className="fa-solid fa-plus me-2" />
          {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.ADD'})}
        </button>
        <AddDhcpLeaseModal
          show={showAdd}
          onHide={() => setShowAdd(false)}
          onAdd={(lease) => addLease.mutate({ip: lease.ip, mac: lease.mac})}
        />
      </Card.Body>
    </Card>
  );
};

export default DhcpLeasesSection;
